import { SVGIconProps } from './types'

export const ThumbsDownIcon = (props: SVGIconProps) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.6249 8.12498L8.1249 13.75C7.62762 13.75 7.1507 13.5524 6.79907 13.2008C6.44744 12.8492 6.2499 12.3723 6.2499 11.875V9.37498H2.7124C2.5312 9.37703 2.35173 9.33967 2.18641 9.26547C2.0211 9.19127 1.87389 9.08202 1.75499 8.94529C1.63608 8.80855 1.54833 8.64759 1.49781 8.47357C1.44729 8.29956 1.4352 8.11663 1.4624 7.93748L2.3249 2.31248C2.3701 2.01442 2.5215 1.74273 2.75121 1.54748C2.98091 1.35223 3.27344 1.24657 3.5749 1.24998H10.6249M10.6249 8.12498V1.24998M10.6249 8.12498H12.2936C12.6474 8.13124 12.9911 8.0074 13.2595 7.77697C13.528 7.54654 13.7025 7.22557 13.7499 6.87498V2.49998C13.7025 2.14939 13.528 1.82842 13.2595 1.59799C12.9911 1.36757 12.6474 1.24373 12.2936 1.24998H10.6249"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
